<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeEditionAssetSignedStudentsDropDownFilters"
  >
    <form
      autocomplete="off"
      spellcheck="false"
      @submit.prevent="searchAdvancedFilter"
    >
      <section class="m-dropdown-section">
        <ul class="m-dropdown-list">
          <li>
            <a href="#">
              {{ $t('mEditionAssetSignedStudentsDropDownFilters.input.estado.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model="filter.activa"
                :elements="estados"
                key-field="id"
                name="activa"
                reference="activa"
                text-field="name"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a href="#">
              {{ $t('mEditionAssetSignedStudentsDropDownFilters.input.search.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.search"
                class="a-input-primary"
                name="search"
                :placeholder="$t('mEditionAssetSignedStudentsDropDownFilters.input.search.placeholder')"
                type="text"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionAssetSignedStudentsDropDownFilters.input.fecha.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_desde"
                label=""
                name="fecha_desde"
                :placeholder="$t('mEditionAssetSignedStudentsDropDownFilters.input.fecha.desde.placeholder')"
              />
              <span class="margin-bottom-xlarge"></span>
              <AtomDatePicker
                v-model="filter.fecha_hasta"
                :disabled-dates="disabledDates"
                name="fecha_hasta"
                :placeholder="$t('mEditionAssetSignedStudentsDropDownFilters.input.fecha.hasta.placeholder')"
              />
            </div>
          </li>
        </ul>
      </section>
      <footer class="m-dropdown-footer">
        <button
          class="a-button-dropdown-secondary"
          @click="reloadListing"
        >
          {{ $t('mEditionAssetSignedStudentsDropDownFilters.buttons.reload') }}
        </button>
        <button
          class="a-button-primary a-button-assets-primary a-button-dropdown-primary"
          type="submit"
        >
          {{ $t('mEditionAssetSignedStudentsDropDownFilters.buttons.search') }}
        </button>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetSignedStudentsDropDownFilters',

  props: {
    filterSeted: Object
  },

  data () {
    return {
      disabledDates: {
        to: ''
      },

      estados: [
        {
          id: '',
          name: 'Todos los estados'
        },
        {
          id: 1,
          name: 'Activas'
        },
        {
          id: 0,
          name: 'Inactivas'
        }
      ],

      filter: {
        activa: '',
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        search: ''
      }
    }
  },

  watch: {
    'filter.fecha_desde' () {
      if (this.$moment(this.filter.fecha_desde).isAfter(this.filter.fecha_hasta)) {
        this.filter.fecha_hasta = null
      }

      this.disabledDates = {
        to: this.filter.fecha_desde
      }
    },

    filterSeted: {
      deep: true,

      handler () {
        this.filter.activa = this.filterSeted.activa
        this.filter.fecha_desde = this.filterSeted.fecha_desde
        this.filter.fecha_hasta = this.filterSeted.fecha_hasta
        this.filter.search = this.filterSeted.search

        this.disabledDates = {
          to: this.filter.fecha_desde
        }
      },

      immediate: true
    }
  },

  methods: {
    reloadListing () {
      this.$emit('reloadListing')
    },

    searchAdvancedFilter () {
      this.$dropDown.switchDropDown('MoleculeEditionAssetSignedStudentsDropDownFilters')
      this.$emit('searchAdvancedFilter', this.filter)
    }
  }
}
</script>
